export default __webpack_public_path__ + "static/media/TATVA_1.b0e74f26.pdf";